import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { List, Button, Dialog, SwipeAction, Image } from "antd-mobile";
import styles from "./GrammaList.module.css"
import ItemJP from "./ItemGramma.js";


const states = require("../../../../utils/states.js")

var reorder = true;
var _orderArr = [];

var curList = [];
function shuffleArray(N) {
  // 创建一个从0到N的数组
  const arr = Array.from({ length: N + 1 }, (_, i) => i);

  // 使用 Fisher-Yates Shuffle 算法打乱数组
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]]; // 交换元素
  }

  return arr;
}
export default forwardRef((props, mref) => {
  // console.warn('这是GrammaList组件')
  const ref = useRef(null);
  const refs = useRef([])
  const ref_listDiv = useRef(null)
  const [trig, setTrig] = useState(0)
  function refreshItem_AfterEdit(index, gramma) {
    console.warn('刷新组件，在编辑之后。refreshItem,index = ', index)
    var gramma = states.grammasWrap.cur_edit_gramma
    curList[index] = gramma
    refs.current[index]?.refresh()
  }
  function refreshList_AfterAdd(newGramma) {
    var l = states.grammasWrap.list;
    var g = l[l.length - 1];
    curList.push(g);
    reorder = false;
    setTrig(trig + 1);
  }
  const scrollBottom = () => {
    console.log('触发滚动条滚动到底 scroll bottom')
    if (ref_listDiv.current) {
      ref_listDiv.current.scrollTop = ref_listDiv.current.scrollHeight
    }
  }
  //刷新页面(是否保存位置信息,默认为false)
  function refreshList(saveScroll) {
    console.warn('grammalist refresh')
    reorder = true
    // setTrig(trig + 1)
  }
  useImperativeHandle(mref, () => ({
    scrollBottom,
    refreshList,
    refreshItem: refreshItem_AfterEdit,
    refreshAfterAdd: refreshList_AfterAdd,
  }))

  async function test() {

    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    
    console.log(states.rootTagsWrap.list)
  }


  //添加按钮
  const onAddClicked = () => {
    props.funcs.AddGramma(() => { console.log('ModeList::完成回调') });
  }
  //是否根据随机顺序来排序
  if (reorder) {
    if (states.filterWrap.cur_gramma_filter.arrange === 'random') {//随机排序
      curList = []
      console.warn('随机排序！当前的wrap.list = ', states.grammasWrap.list)
      if (states.grammasWrap.list && states.grammasWrap.list.length > 0) {
        _orderArr = shuffleArray(states.grammasWrap.list.length - 1)
        for (let i = 0; i < _orderArr.length; i++) {
          curList.push(states.grammasWrap.list[_orderArr[i]])
        }
      }
    } else { //默认排序
      console.log('默认排序!')
      curList = []
      curList = structuredClone(states.grammasWrap.list)
    }
    reorder = false;
  }
  // console.warn('渲染的list:',curList)


  //#region 头部
  var info = states.curBookInfo();
  var head_str1 = info.bGrammaBook ? '● 语法本' : `● 单词本：${info.bookName}`
  var head_str2 = `● level：${info.level_min} ~ ${info.level_max} `
  var head_strArrange = `● 排序模式：${info.arrange}`
  var head_str3 = info.bGrammaBook ?
    `词根：${info.roots}  代词：${info.preps}  形式：${info.forms}` :
    `tags：${info.tags}`
  //#endregion











  return (<div className={styles.app}>
    <div className={styles.top}>
      <div>&emsp;{head_str1}&emsp;{head_str2}&emsp;{head_strArrange}</div>
      <div>&emsp;{head_str3}</div>
    </div>
    <div ref={ref_listDiv} className={styles.list}>
      <List trig={trig} mode="card" style={{ 'paddingRight': 0 }}>
        {curList?.map((item, index) => (
          <SwipeAction className={styles.swiper} key={index} rightActions={[
            {
              key: 'edit',
              text: ' 编 辑 ',
              color: '#50dd75',
              onClick: (ev) => {
                props.funcs.EditGramma(item.id, index)
                console.warn('最早id:', index)
              }
              ,
            }, {
              key: 'delete',
              text: ' 删 除 ',
              color: 'danger',
              onClick: async () => {
                let sig = await Dialog.confirm({
                  content: '确定要删除吗？',
                })
                if (sig) {
                  await states.DeleteGramma(item.id, async (b) => {
                    console.log('b=', b)
                    if (b) {//删除完成,重新下载list
                      await states.downloadGrammaBook()
                      refreshList()
                    } else {//删除失败,啥都不干
                    }
                  })
                }
                ref.current?.close()
              }
            }]
          }>
            <List.Item style={{ height: '100px', '--padding-left': 0, '--padding-right': 11 }}>
              <ItemJP ref={(el) => { refs.current[index] = el }} item={item} order={index} disp=
                {states.filterWrap.cur_gramma_filter.display} />
            </List.Item>
          </SwipeAction>
        ))}
      </List>
    </div>
    <div className={styles.bottom}>
      <Button onClick={onAddClicked} className={styles.bottomBtn}>添加记录</Button>
      {/* <Button onClick={test} className={styles.bottomBtn}>TEST1</Button> */}
    </div>

  </div >)
})